import Logo from "@/components/zeblan/Logo";

export default function Footer({ onOpenLead }) {
  return (
    <footer className="bg-navy text-mist/85 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <Logo variant="teal" className="h-20 w-auto" />
          <p className="mt-6 text-[15px] leading-relaxed max-w-md text-mist/75">
            Secure, custom AI agents for mid-sized companies. Built by people who understand business, kept on your
            servers, under your control.
          </p>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-3 gap-8">
          <div>
            <div className="text-white text-[12px] font-bold uppercase tracking-[0.22em]">Company</div>
            <ul className="mt-5 space-y-3 text-[14px]">
              <li><a href="#our-story" className="hover:text-teal transition-colors">Our Story</a></li>
              <li><a href="#why" className="hover:text-teal transition-colors">Why Zeblan</a></li>
              <li><a href="#how-we-work" className="hover:text-teal transition-colors">Aftercare</a></li>
            </ul>
          </div>
          <div>
            <div className="text-white text-[12px] font-bold uppercase tracking-[0.22em]">What we do</div>
            <ul className="mt-5 space-y-3 text-[14px]">
              <li><a href="#services" className="hover:text-teal transition-colors">Services</a></li>
              <li><a href="#how-we-work" className="hover:text-teal transition-colors">How We Work</a></li>
              <li><a href="#use-cases" className="hover:text-teal transition-colors">Use Cases</a></li>
              <li><a href="#pricing" className="hover:text-teal transition-colors">Pricing</a></li>
            </ul>
          </div>
          <div>
            <div className="text-white text-[12px] font-bold uppercase tracking-[0.22em]">Get started</div>
            <ul className="mt-5 space-y-3 text-[14px]">
              <li>
                <button type="button" onClick={() => onOpenLead("roi-assessment")} className="hover:text-teal transition-colors text-left">
                  Free ROI Assessment
                </button>
              </li>
              <li>
                <button type="button" onClick={() => onOpenLead("drop-a-line")} className="hover:text-teal transition-colors text-left">
                  Drop us a line
                </button>
              </li>
              <li>
                <a href="mailto:hello@zeblan.com" className="hover:text-teal transition-colors">hello@zeblan.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[13px]">
        <span className="text-mist/55">© 2026 Zeblan. All rights reserved.</span>
        <span className="font-display italic text-teal text-[16px]">Intelligence in motion.</span>
      </div>
    </footer>
  );
}
